export default __webpack_public_path__ + "static/media/status_icona.76804bb8.svg";